import { IEnvironment } from '@inshuwa-client/models';
import { devBaseUrl } from 'libs/core/src/lib/configs/constants';

export const environment: IEnvironment = {
  insurerId: null,
  partnerId: null,
  primaryColor: '#520B4D',
  secondaryColor: '#d8205a',
  name: 'Inshuwa',
  logoUrl: '../assets/inshuwa_logo.png',
  baseURL: devBaseUrl,
  debug: true,
  favIcon: '../assets/favicon.ico',
  portalName: 'Inshuwa Portal dev',
  colorPlate: ['#520b4d', '#912354', '#c54c52', '#e9804e', '#fbbb52'],
};
